import type { SpaceCredits } from '@/shared/types/Space';

import { isPaidSubscription } from './isPaidSubscription';
import { getTrialRecordingState, RecordingFreeMinutes, TRIAL_RECORDING_MAX_SECONDS } from './trialRecording';

export type RecordingEntitlement =
  | { freeMinutes?: RecordingFreeMinutes; status: 'limited' | 'loading' }
  | { status: 'unlimited' };

type SpaceRecordingCredits = {
  credits?: Partial<Pick<SpaceCredits['credits'], 'recording_free_minutes'>>;
} & Pick<SpaceCredits, 'subscription'>;

export const getRecordingEntitlement = (
  spaceCredits: null | SpaceRecordingCredits | undefined,
  isPaidTrial = false,
): RecordingEntitlement => {
  if (!spaceCredits) return { status: 'loading' };
  if (isPaidSubscription(spaceCredits.subscription, isPaidTrial)) return { status: 'unlimited' };

  return { freeMinutes: spaceCredits.credits?.recording_free_minutes, status: 'limited' };
};

export const getRecordingMaxDurationSeconds = (entitlement: RecordingEntitlement): number | undefined =>
  entitlement.status === 'unlimited' ? undefined : TRIAL_RECORDING_MAX_SECONDS;

export const isOutOfRecordingMinutes = (entitlement: RecordingEntitlement): boolean => {
  if (entitlement.status === 'unlimited' || !entitlement.freeMinutes) return false;

  return getTrialRecordingState(entitlement.freeMinutes) === 'used';
};
